export enum InterestPaymentFrequencyEnum {
    ANNUALLY = '1',
    SEMI_ANNUALLY = '2',
    QUARTERLY = '4',
    MONTHLY = '12',
    DAILY = '365',
    COMPOUND = 'C',
    AT_MATURITY = '-5'
}
